export default __webpack_public_path__ + "static/media/hosting_style.bc6da3ad.gif";